import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class MonthListTask extends GenericRequest {

    _request; // MonthListRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MONTHLY_PRESENCE_MONTHS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/month-list/MonthListTask.js